module.exports = __webpack_public_path__ + "assets/add-camera-drivers.cef1126f.svg";